export enum EClickPosition {
  VIEW_MORE_FEATURES = 'view_more_features',

  BOTTOM_BUTTON = 'bottom_button',
  FEED_BOTTOM_BUTTON = 'feed_bottom_button',
  SEARCH_BOTTOM_BUTTON = 'search_bottom_button',
  INTERACT_BOTTOM_BUTTON = 'interact_bottom_button',
  LEMO_BOTTOM_BUTTON = 'lemo_bottom_button',

  DOWNLOAD_APPSTORE = 'download_appstore',
  DOWNLOAD_GOOGLE_PLAY = 'download_googleplay',

  TOP_BAR_SIDE = 'top_bar_side',
  TOP_BAR_SHARE = 'top_bar_share',

  SHARE_PANEL_ICON = 'share_panel_icon',
  LANGUAGE_SWITCH = 'language_switch',
}
